import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiRequestHeadersService } from './http/api-request-headers.service';
import { SessionHttpErrorHandler } from './http/session-http-error.handler';

/**
 * Thin shell: attach API headers/cookies, then delegate all outcomes to SessionHttpErrorHandler.
 */
@Injectable()
export class AppInterceptorInterceptor implements HttpInterceptor {
  constructor(
    private headers: ApiRequestHeadersService,
    private sessionErrors: SessionHttpErrorHandler,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const enriched = this.headers.enrich(request);
    return this.sessionErrors.interceptChain(request, enriched, next);
  }
}
